import React from 'react';

function formatCellValue(value) {
  if (value === null || value === undefined || value === '') return '-';
  if (Array.isArray(value)) return value.length ? value.join(', ') : '-';
  if (typeof value === 'object') return value.name ?? '-';
  if (typeof value === 'boolean') return value ? 'Yes' : 'No';
  return value;
}

function TableContent({ headers, vehicleTrackings, onVehicleCodeClick }) {
  const paddingMode = localStorage.getItem('paddingMode') || 'comfy';

  return (
    <tbody>
      {vehicleTrackings?.length > 0 ? (
        vehicleTrackings.map((vehicleTracking) => (
          <tr key={vehicleTracking.id}>
            {headers.map((header, index) => (
              <td
                className={`table-data ${
                  paddingMode === 'compact'
                    ? 'compact-padding'
                    : 'comfortable-padding'
                }`}
                key={header.value}
              >
                <div className="div-flex-row div-align-center cg-5">
                  {index === 0 && (
                    <input type="checkbox" className="checkbox-grey" />
                  )}
                  {header.value === 'vehicle_tracking_code' ? (
                    <button
                      type="button"
                      data-testid="vehicle-tracking-code-link"
                      className="link-text-blue icon-btn-none"
                      onClick={() => onVehicleCodeClick(vehicleTracking)}
                    >
                      <span className="text-blue">
                        {vehicleTracking[header.value]}
                      </span>
                    </button>
                  ) : (
                    <span>
                      {formatCellValue(vehicleTracking[header.value])}
                    </span>
                  )}
                </div>
              </td>
            ))}
          </tr>
        ))
      ) : (
        <div className="no-list-data-message border-bottom">
          <span className="text-sm">No Vehicle Tracking Found</span>
        </div>
      )}
    </tbody>
  );
}

export default TableContent;
